import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Amplify } from 'aws-amplify';
import { AuthProvider } from './hooks/useAuth';
import { ProtectedRoute } from './components/ProtectedRoute';

import { theme } from './theme';
import Layout from './components/Layout';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import { Checkout } from './pages/Checkout';
import Profile from './pages/Profile';
import AdminDashboard from './pages/AdminDashboard';
import NotFound from './pages/NotFound';
import LoginForm from './components/auth/LoginForm';
import RegisterForm from './components/auth/RegisterForm';
import CreatePostcard from './pages/CreatePostcard';
import Success from './pages/Success';
import BuyTokens from './pages/BuyTokens';
import TokenPurchaseSuccess from './pages/TokenPurchaseSuccess';
import { PostcardDetails } from './pages/PostcardDetails';
import { TemplateDetails } from './pages/TemplateDetails';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Contact from './pages/Contact';

// Configure Amplify
Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_AWS_REGION || 'eu-west-1',
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
    userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
  },
  API: {
    endpoints: [
      {
        name: 'cardai',
        endpoint: process.env.REACT_APP_API_URL || '/api',
        region: process.env.REACT_APP_AWS_REGION || 'eu-west-1',
      },
    ],
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/templates/:templateId" element={<TemplateDetails />} />
            <Route path="/postcards/:postcardId" element={<ProtectedRoute><PostcardDetails /></ProtectedRoute>} />
            <Route path="/checkout/:postcardId" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
            <Route path="/login" element={<LoginForm />} />
            <Route path="/register" element={<RegisterForm />} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>} />
            <Route path="/create/:templateId" element={<ProtectedRoute><CreatePostcard /></ProtectedRoute>} />
            <Route path="/success" element={<ProtectedRoute><Success /></ProtectedRoute>} />
            <Route path="/buy-tokens" element={<ProtectedRoute><BuyTokens /></ProtectedRoute>} />
            <Route path="/tokens/success" element={<ProtectedRoute><TokenPurchaseSuccess /></ProtectedRoute>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App; 